import React from "react";
import { Select } from "antd";

import { Icons } from "components/layout";
import { Localize } from "components/service";

const { Option } = Select;

const DamageStandNumberSelectField = ({ options = [], ...props }) => {
    return (
        <Select
            className="damage-stand-number-select-field"
            suffixIcon={<Icons.Arrow type="filled" />}
            defaultValue={null}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                String(option?.children || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            { ...props }
        >
            <Option value={null}>
                <Localize>FORMS.Select_DefaultValue_All</Localize>
            </Option>
            {options.map((value) => (
                <Option key={value} value={value}>
                    {value}
                </Option>
            ))}
        </Select>
    );
};

export default DamageStandNumberSelectField;
